import { useTranslation } from "@repo/shared/i18n";
import { useState } from "react";

import { BaseModal } from "../BaseModal";
import { LoginSection } from "./LoginSection";

interface Props {
  onClose: () => void;
  title: string;
  description?: string;
}

export const LoginModal = ({ onClose, title, description }: Props) => {
  const { t } = useTranslation("auth");
  const [showCodeScreen, setShowCodeScreen] = useState(false);

  const currentTitle = showCodeScreen ? t("login.emailedCode") : title;
  const currentDescription = showCodeScreen ? undefined : description;

  return (
    <BaseModal
      title={currentTitle}
      description={currentDescription}
      onClose={onClose}
      showCloseButton
      className="px-8 mobile:px-8 h-110"
      // The login screen has an extra OAuth button (Apple) so it needs more
      // height than the code-entry screen to fit the error line without
      // overflowing the modal.
      // className={cn("px-8 mobile:px-8", showCodeScreen ? "h-110" : "h-130")}
      type="action"
    >
      <LoginSection
        onClose={onClose}
        onScreenChange={(screen) => setShowCodeScreen(screen === "code")}
      />
    </BaseModal>
  );
};
